<template>
	<el-upload class="file-upload" :class="{ 'file-upload--loading': isUploading }" :action="'#'"
		:http-request="onFileUpload" :accept="fileTypes == null ? '' : fileTypes.join(',')"
		:show-file-list="false" :disabled="disabled" :before-upload="beforeUpload" :multiple="multiple"
		:aria-busy="isUploading ? 'true' : 'false'">
		<slot></slot>
		<span v-if="showLoading && isUploading" class="file-upload__loading" title="正在上传" @click.stop>
			<i class="el-icon-loading"></i>
		</span>
	</el-upload>
</template>

<script>
import { uploadProtectedAsset } from '../../api/protectedAssetUpload';

export default {
	name: "fileUpload",
	data() {
		return {
			uploadingCount: 0,
			pendingUploads: new Map()
		}
	},
	props: {
		action: {
			type: String,
			required: false
		},
		fileTypes: {
			type: Array,
			default: null
		},
		maxSize: {
			type: Number,
			default: null
		},
		showLoading: {
			type: Boolean,
			default: false
		},
		isPermanent: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		multiple: {
			type: Boolean,
			default: true
		},
		beforeCheck: {
			type: Function,
			default: null
		},
		uploadTimeout: {
			type: Number,
			default: 10 * 60 * 1000
		}
	},
	methods: {
		async onFileUpload(file) {
			if (this.showLoading) {
				this.uploadingCount++;
			}
			try {
				const sourceFile = this.resolveUploadFile(file);
				const data = await uploadProtectedAsset(sourceFile, {
					action: this.action,
					isPermanent: this.isPermanent,
					timeout: this.uploadTimeout
				});
				this.$emit("success", data, sourceFile, file || sourceFile);
			} catch (e) {
				const sourceFile = this.resolveUploadFile(file);
				this.$emit("fail", e, sourceFile, file || sourceFile);
			} finally {
				this.clearUploadFile(file);
				if (this.showLoading) {
					this.uploadingCount = Math.max(0, this.uploadingCount - 1);
				}
			}
		},
		beforeUpload(file) {
			// 校验文件类型
			if (this.fileTypes && this.fileTypes.length > 0) {
				const fileType = String(file.type || '').toLowerCase();
				let t = this.fileTypes.find((type) => String(type || '').toLowerCase() === fileType);
				if (t === undefined) {
					this.$message.error(`文件格式错误，请上传以下格式的文件：${this.fileTypes.join(', ')}`);
					return false;
				}
			}
			// 校验大小
			if (this.maxSize && file.size > this.maxSize) {
				this.$message.error(`文件大小不能超过 ${this.fileSizeStr}!`);
				return false;
			}
			if (this.beforeCheck && this.beforeCheck(file) === false) {
				return false;
			}
			this.$emit("before", file);
			this.rememberUploadFile(file);
			return true;
		},
		getUploadKey(file) {
			const sourceFile = file && file.file ? file.file : file;
			return sourceFile && sourceFile.uid != null ? String(sourceFile.uid) : '';
		},
		rememberUploadFile(file) {
			const key = this.getUploadKey(file);
			if (!key) {
				return;
			}
			const sourceFile = file && file.file ? file.file : file;
			this.pendingUploads.set(key, sourceFile || file);
		},
		resolveUploadFile(file) {
			const key = this.getUploadKey(file);
			if (key && this.pendingUploads.has(key)) {
				return this.pendingUploads.get(key);
			}
			return file && file.file ? file.file : file;
		},
		clearUploadFile(file) {
			const key = this.getUploadKey(file);
			if (key) {
				this.pendingUploads.delete(key);
			}
		}
	},
	computed: {
		isUploading() {
			return this.uploadingCount > 0;
		},
		fileSizeStr() {
			if (this.maxSize > 1024 * 1024) {
				return Math.round(this.maxSize / 1024 / 1024) + "M";
			}
			if (this.maxSize > 1024) {
				return Math.round(this.maxSize / 1024) + "KB";
			}
			return this.maxSize + "B";
		}
	}
}
</script>

<style scoped lang="scss">
.file-upload {
	position: relative;
	display: inline-flex;
	vertical-align: top;

	&__loading {
		position: absolute;
		z-index: 2;
		inset: 0;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: inherit;
		background: rgba(var(--im-black-rgb), 0.5);
		color: var(--im-text-color-white);
		font-size: 20px;
		cursor: wait;
	}
}
</style>
